import React from 'react';
import { MinusIcon, SparkleIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
import { beforeItems, afterItems } from '../data/content';
export function TransformationSection() {
  return <section className="border-t border-white/5 bg-void-950 py-24 md:py-32" data-id="element-212" data-mp="2wvsyv2zpmqpe">
      <div className="mx-auto max-w-5xl px-6" data-id="element-213" data-mp="2rxrfegydgpde">
        <Reveal className="max-w-2xl" data-id="element-214" data-mp="2nwz5rmll8igl">
          <SectionLabel data-id="element-215" data-mp="2ny0qkiseojbi">La transformación</SectionLabel>
          <h2 className="font-display text-3xl font-light leading-tight text-bone-50 sm:text-4xl md:text-5xl" data-id="element-216" data-mp="2j68yu4xik7js">
            Antes y después de despertar.
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-8 md:grid-cols-2" data-id="element-217" data-mp="2e51oby3zku9f">
          <Reveal data-id="element-218" data-mp="2994du8femi4k">
            <div className="h-full rounded-sm border border-white/5 bg-void-900/60 p-8" data-id="element-219" data-mp="299md7dxd5cgp">
              <p className="text-[11px] uppercase tracking-label text-bone-500" data-id="element-220" data-mp="248glnjffvv8r">Antes</p>
              <h3 className="mt-4 font-display text-2xl font-light text-bone-300" data-id="element-221" data-mp="208o9kwqu76yn">
                Cómo te sientes hoy
              </h3>
              <ul className="mt-7 space-y-4" data-id="element-222" data-mp="f8zn24gwh40h">
                {beforeItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-223" data-mp="k3vpzznodbsd">
                    <MinusIcon className="mt-1 h-4 w-4 shrink-0 text-bone-500" aria-hidden="true" data-id="element-224" data-mp="5e7kem8gnqyu" />
                    <span className="text-sm leading-relaxed text-bone-300" data-id="element-225" data-mp="y124hi1d8obs">{item}</span>
                  </li>)}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.08} data-id="element-226" data-mp="p0vtc2t540fs">
            <div className="neon-panel h-full rounded-sm border border-gold-500/30 bg-void-900 p-8" data-id="element-227" data-mp="p1niaus8ezx3">
              <p className="neon-text-soft text-[11px] uppercase tracking-label text-gold-500" data-id="element-228" data-mp="t1fqv7hml62g">
                Después
              </p>
              <h3 className="mt-4 font-display text-2xl font-light text-bone-50" data-id="element-229" data-mp="39t7fcectnzq6">
                Cómo puedes sentirte
              </h3>
              <ul className="mt-7 space-y-4" data-id="element-230" data-mp="1k9pm2g1poyen">
                {afterItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-231" data-mp="1fb61ok2rnuoe">
                    <SparkleIcon className="mt-1 h-4 w-4 shrink-0 text-gold-500 drop-shadow-[0_0_8px_rgba(34,227,127,0.7)]" aria-hidden="true" data-id="element-232" data-mp="1fcz8bzddqewe" />
                    <span className="text-sm leading-relaxed text-bone-100" data-id="element-233" data-mp="15j8mz3cjukkx">{item}</span>
                  </li>)}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}